export const Warning = '温馨提示：上传图片时请以4:3、16:9、16:10、1:1的比例上传'

export const Option = {
  1: {
    titletype: 'chapter_title',
    name: '简章标题',
    fixed: !1,
    title: '主标题',
    subtitle: '副标题',
    upload: '上传图片',
    content: '内容',
    uploadBtn: '添加',
    placeholder: '',
    subplaceholder: '',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。'
  },
  2: {
    titletype: 'school_profile',
    name: '院校简介',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    uploadBtn: '添加',
    placeholder: '院校简介',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。',
    subplaceholder: 'SCHOOL PROFILE'
  },
  3: {
    titletype: 'quality_resources',
    name: '班制优势',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    uploadBtn: '添加',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。',
    placeholder: '班制优势/QUALITY RESOURCES',
    subplaceholder: ''
  },
  4: {
    titletype: 'training_mode',
    name: '培养模式',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    uploadBtn: '添加',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。',
    placeholder: '培养模式/TRAINING MODE',
    subplaceholder: '培养模式/TRAINING MODE'
  },
  5: {
    titletype: 'employment_recommendation',
    name: '就业推荐',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    uploadBtn: '添加',
    placeholder: '就业推荐',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。',
    subplaceholder: '就业推荐/EMPLOYMENT RECOMMENDATION'
  },
  6: {
    titletype: 'professiomal_curriculum',
    name: '开设专业',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    placeholder: '开设专业',
    uploadBtn: '添加',
    subplaceholder: 'PROFESSIONAL CURRICULUM',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。'
  },
  7: {
    titletype: 'place_of_study',
    name: '学习地点',
    title: '主标题',
    subtitle: '副标题',
    uploadBtn: '添加',
    upload: '上传图片',
    placeholder: '学习地点/PLACE OF STUDY',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。',
    subplaceholder: 'PLACE OF STUDY'
  },
  8: {
    titletype: 'campus_scenery',
    name: '校园风光',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    placeholder: '校园风光',
    subplaceholder: 'CAMPUS SCENERY',
    uploadBtn: '添加',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。'
  },
  9: {
    titletype: 'registration_matters',
    name: '报名事项',
    title: '主标题',
    subtitle: '副标题',
    content: '内容',
    upload: '上传图片',
    uploadBtn: '添加',
    uploadCnt: 6,
    warning: '最多上传6张，4张以内为平铺,超过4张为轮播形式展示。',
    placeholder: '报名事项',
    subplaceholder: 'REGISTRATION MATTERS'
  }
}
